module.exports = __webpack_public_path__ + "static/media/drafting-compass.5777e8a1.svg";